import { TransitionService } from "@uirouter/angularjs";

export interface IThemeDefinition {
    name: string;

    accentColourLightest: string;
    accentColourLighter: string;
    accentColour: string;
    accentColourDarker: string;
    accentColourDarkest: string;

    bodyClass?: string;
    favIcon?: string;
}

export class ThemeService {

    currentTheme: IThemeDefinition;
    private themes: IThemeDefinition[] = [];
    readonly defaultThemeName = "default";

    static $inject = ["$document", "$transitions"];

    constructor(private readonly $document: angular.IDocumentService, private readonly $transitions: TransitionService) {

        $transitions.onEnter({}, (transition, state) => {
            if (state.data) {

                this.setTheme(state.data.theme);
            }
        });

        this.createThemes();
        this.setTheme(null);
    }

    // ---

    private setTheme(themeName = this.defaultThemeName) {
        var newTheme = this.themes.find(t => t.name == themeName) || this.themes[0];

        var previousTheme = this.currentTheme;
        this.currentTheme = newTheme;

        if (previousTheme?.bodyClass) {
            this.$document[0].body.classList.remove(previousTheme.bodyClass);
        }

        if (this.$document) {

            this.$document[0].body.style.setProperty("--accent-color-lightest", this.currentTheme.accentColourLightest);
            this.$document[0].body.style.setProperty("--accent-color-lighter", this.currentTheme.accentColourLighter);
            this.$document[0].body.style.setProperty("--accent-color", this.currentTheme.accentColour); // rgb(255,110,64)
            this.$document[0].body.style.setProperty("--accent-color-darker", this.currentTheme.accentColourDarker);
            this.$document[0].body.style.setProperty("--accent-color-darkest", this.currentTheme.accentColourDarkest);

            // FA Duotone global style
            this.$document[0].body.style.setProperty("--fa-secondary-opacity", "0.6");

            if (this.currentTheme.bodyClass) {
                this.$document[0].body.classList.add(this.currentTheme.bodyClass);
            }
        }

        this.changeFavicon(newTheme.favIcon || "/assets/images/logos/addsecure-favicon-32.ico");
    }

    private createThemes() {
        var defaultTheme: IThemeDefinition = {
            name: this.defaultThemeName,
            accentColourLightest: "rgba(255,110,64 ,.5)",
            accentColourLighter: "rgba(255,110,64,.7)",
            accentColour: "rgb(255,110,64)",
            accentColourDarker: "#ff5620",
            accentColourDarkest: "#ff3e00",
            bodyClass: "valkyrie"
        }

        var addSecureTheme: IThemeDefinition = {
            name: "AddSecure",
            accentColourLightest: "rgba(0, 76, 147 ,.5)",
            accentColourLighter: "rgba(0, 76, 147,.7)",
            accentColour: "rgb(0, 76, 147)",
            accentColourDarker: "#004484",
            accentColourDarkest: "#003d76",
            bodyClass: "foundation",
            favIcon: "/assets/images/logos/addsecure-favicon-32.ico"
        }

        // Default theme now uses AST colours
        defaultTheme.accentColourLightest = addSecureTheme.accentColourLightest;
        defaultTheme.accentColourLighter = addSecureTheme.accentColourLighter;
        defaultTheme.accentColour = addSecureTheme.accentColour;
        defaultTheme.accentColourDarker = addSecureTheme.accentColourDarker;
        defaultTheme.accentColourDarkest = addSecureTheme.accentColourDarkest;

        this.themes.push(defaultTheme);
        this.themes.push(addSecureTheme);

        // https://mdigi.tools/darken-color/#004c93
        // https://www.colorhexa.com/004c93
    }

    private changeFavicon(faviconUrl: string) {
        const link = document.createElement('link');

        const oldLinks = document.querySelectorAll('link[rel="icon"]');
        oldLinks.forEach(e => e.parentNode.removeChild(e));

        link.id = 'dynamic-favicon';
        link.rel = 'icon';
        link.href = faviconUrl;
        document.head.appendChild(link);
    }

    private changeFaviconUsingCanvas(text) {
        //this.changeFavicon('❤️');
        const canvas = document.createElement('canvas');
        canvas.height = 64;
        canvas.width = 64;
        const ctx = canvas.getContext('2d');
        ctx.font = '64px serif';
        ctx.fillText(text, 0, 64);

        const link = document.createElement('link');
        const oldLinks = document.querySelectorAll('link[rel="shortcut icon"]');
        oldLinks.forEach(e => e.parentNode.removeChild(e));
        link.id = 'dynamic-favicon';
        link.rel = 'shortcut icon';
        link.href = canvas.toDataURL();
        document.head.appendChild(link);
    }
}
